export default "__VITE_ASSET__39e5b191__"